import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { inject } from '@angular/core';
import { NewsletterService } from '../../services/newsletter.service';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterLink, FormsModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
  private newsletterService = inject(NewsletterService);
  email = '';
  
  subscribe() {
    if (!this.email) return;
    this.newsletterService.subscribe(this.email).subscribe({
      next: () => {
        alert('Subscribed successfully!'); // Should use ToastService
        this.email = '';
      },
      error: () => alert('Failed to subscribe. Please try again.')
    });
  }
}
